module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARxJREFUWEftl6FOA0EURc9N+AAUBoMAgyV4DAg8gi/gB6CVtI5AcKSCH0BgkRWthu/oH1TfZppdQic7QDZMZhP2qTXv3TNv5t2ZFYVDhfXpFoDtE2Af2M3YmbmkWV1/owO2b4D7jOKh9EDSQwrgEjgD9jJCPEt6aQTIKJos3a1D2Hegsx2o/GFL0tT2NjAFjloAL4ArSW+/ngLbI+AWOK0AgvBHC/E65VrS448Ato8rUwruGGINED5sHwI7LSHeJS2/BbA9BO4igU+AlsKNabEVHwBPlRvGCf8AoF5ysS342vOihzACKTOGEUQYxTJG9Jcj11Srv477DsRWfAGcZ36UTiS9pl7F4doNc58zRpLGKYCyPyY5l52q3U/BCj1QbiHI/4wsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mlBtn.png
// module id = fmQk
// module chunks = 1